import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "portal-page info-story" }
const _hoisted_2 = { class: "portal-page__inner" }
const _hoisted_3 = {
  key: 0,
  class: "info-story__status"
}
const _hoisted_4 = {
  key: 1,
  class: "info-story__card portal-panel"
}
const _hoisted_5 = { class: "info-story__kicker" }
const _hoisted_6 = { class: "info-story__title" }
const _hoisted_7 = { class: "info-story__date" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "info-story__summary" }

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { fetchInfoStory, type InfoStory } from '@/api/infoCenter'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoStoryPage',
  setup(__props) {

const route = useRoute()
const story = ref<InfoStory | null>(null)
const errorMessage = ref('')

function formatDate(value: string) {
  return String(value || '').replace(/-/g, '.')
}

onMounted(async () => {
  try {
    story.value = await fetchInfoStory(Number(route.params.idx))
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '소식을 불러오지 못했습니다.'
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errorMessage.value), 1))
        : (story.value)
          ? (_openBlock(), _createElementBlock("article", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(story.value.categoryLabel), 1),
              _createElementVNode("h1", _hoisted_6, _toDisplayString(story.value.title), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(formatDate(story.value.publishedAt)), 1),
              (story.value.heroImage || story.value.thumb)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "info-story__image",
                    src: story.value.heroImage || story.value.thumb,
                    alt: ""
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_9, _toDisplayString(story.value.summary), 1),
              _createVNode(_component_router_link, {
                to: "/info",
                class: "portal-btn portal-btn--secondary"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("정보마당 목록", -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})